module.exports = __webpack_public_path__ + "media/male_resultA.1eb3423c.mp3";